"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const core_1 = require("@aws-amplify/core");
exports.logger = new core_1.ConsoleLogger('Storage');
